<template>
    <Section id="testimonials">
        <template #section>
            {{ $t('budgets_landing_page.testimonials') }}
        </template>
        <template #title>
            {{ $t('budgets_landing_page.testimonials_subtitle') }}
        </template>
        <div class="lg:grid-cols-3 grid gap-8">
            <div v-for="testimonialsChunk in testimonialsChunks">
                <ul class="flex flex-col space-y-8">
                    <li v-for="testimonial in testimonialsChunk">
                        <figure class="relative p-4 bg-white rounded-lg shadow-xl">
                            <svg aria-hidden="true" width="105" height="78" class="absolute text-gray-200 fill-current"><path d="M25.086 77.292c-4.821 0-9.115-1.205-12.882-3.616-3.767-2.561-6.78-6.102-9.04-10.622C1.054 58.534 0 53.411 0 47.686c0-5.273.904-10.396 2.712-15.368 1.959-4.972 4.746-9.567 8.362-13.786a59.042 59.042 0 0 1 12.43-11.3C28.325 3.917 33.599 1.507 39.324 0l11.074 13.786c-6.479 2.561-11.677 5.951-15.594 10.17-3.767 4.219-5.65 7.835-5.65 10.848 0 1.356.377 2.863 1.13 4.52.904 1.507 2.637 3.089 5.198 4.746 3.767 2.41 6.328 4.972 7.684 7.684 1.507 2.561 2.26 5.5 2.26 8.814 0 5.123-1.959 9.19-5.876 12.204-3.767 3.013-8.588 4.52-14.464 4.52Zm54.24 0c-4.821 0-9.115-1.205-12.882-3.616-3.767-2.561-6.78-6.102-9.04-10.622-2.11-4.52-3.164-9.643-3.164-15.368 0-5.273.904-10.396 2.712-15.368 1.959-4.972 4.746-9.567 8.362-13.786a59.042 59.042 0 0 1 12.43-11.3C82.565 3.917 87.839 1.507 93.564 0l11.074 13.786c-6.479 2.561-11.677 5.951-15.594 10.17-3.767 4.219-5.65 7.835-5.65 10.848 0 1.356.377 2.863 1.13 4.52.904 1.507 2.637 3.089 5.198 4.746 3.767 2.41 6.328 4.972 7.684 7.684 1.507 2.561 2.26 5.5 2.26 8.814 0 5.123-1.959 9.19-5.876 12.204-3.767 3.013-8.588 4.52-14.464 4.52Z"></path></svg>
                            <div class="relative">
                                <p class="text-sm tracking-tight">
                                    {{ testimonial.content }}
                                </p>
                            </div>
                            <figcaption class="relative flex items-center pt-6 mt-6 border-t border-gray-200">
                                <img :src="testimonial.imagePath" :alt="testimonial.name" class="flex-shrink-0 object-cover object-center w-12 h-12 border border-gray-300 rounded-full" />
                                <span class="flex flex-col flex-grow pl-4">
                                    <span class="title-font text-sm font-medium text-gray-700">{{ testimonial.name }}</span>
                                    <span class="text-sm text-gray-600" v-html="$t('budgets_landing_page.full_job_title', {
                                        jobTitle: testimonial.jobTitle,
                                        companyName: `<a href=&quot;${testimonial.companyWebsite}&quot; class=&quot;text-blue-500&quot; target=&quot;_blank&quot; rel=&quot;noopener noreferrer&quot;>${testimonial.companyName}</a>`,
                                    })"></span>
                                </span>
                            </figcaption>
                        </figure>
                    </li>
                </ul>
            </div>
        </div>
    </Section>
</template>

<script>
import Section from '../../../../shared/section.vue';

export default {
    components: {
        Section,
    },

    computed: {
        testimonials() {
            const testimonials = [
                {
                    content: this.$t('budgets_landing_page.testimonial_1_text', { 'lineBreak': '<br/>' }),
                    imagePath: '/images/marketing/mihai-alexandru-andrei.jpg',
                    name: 'Mihai Alexandru Andrei',
                    jobTitle: 'Operations Director',
                    companyName: 'WebDigital',
                    companyWebsite: 'https://webdigital.ro',
                },
                {
                    content: this.$t('budgets_landing_page.testimonial_2_text', { 'lineBreak': '<br/>' }),
                    imagePath: '/images/marketing/germina-gaga.jpg',
                    name: 'Germina Gâgă',
                    jobTitle: 'Digital Marketing Manager & Founder',
                    companyName: 'Digital Times',
                    companyWebsite: 'https://digitaltimes.ro',
                },
                {
                    content: this.$t('budgets_landing_page.testimonial_3_text', { 'lineBreak': '<br/>' }),
                    imagePath: '/images/marketing/andrei-stan.jpg',
                    name: 'Andrei Stan',
                    jobTitle: 'Digital Marketing Specialist',
                    companyName: 'Zenith',
                    companyWebsite: 'https://zenithmedia.com',
                },
                {
                    content: this.$t('budgets_landing_page.testimonial_4_text', { 'lineBreak': '<br/>' }),
                    imagePath: '/images/marketing/andrei-cozma.jpg',
                    name: 'Andrei Cozma',
                    jobTitle: 'Performance Media Manager',
                    companyName: 'eMAG',
                    companyWebsite: 'https://emag.ro',
                },
                {
                    content: this.$t('budgets_landing_page.testimonial_5_text', { 'lineBreak': '<br/>' }),
                    imagePath: '/images/marketing/alexandru-dragan.jpg',
                    name: 'Alexandru Drăgan',
                    jobTitle: 'Digital Performance Manager',
                    companyName: 'Ideologiq',
                    companyWebsite: 'https://ideologiq.com',
                },
                {
                    content: this.$t('budgets_landing_page.testimonial_6_text', { 'lineBreak': '<br/>' }),
                    imagePath: '/images/marketing/daniela-andriescu.jpg',
                    name: 'Daniela Andriescu',
                    jobTitle: 'PPC Performance Manager',
                    companyName: 'United Media Services',
                    companyWebsite: 'https://unitedmedia.ro',
                },
                {
                    content: this.$t('budgets_landing_page.testimonial_7_text', { 'lineBreak': '<br/>' }),
                    imagePath: '/images/marketing/paula-prahoveanu.jpg',
                    name: 'Paula Prahoveanu',
                    jobTitle: 'Digital Marketing Manager',
                    companyName: 'NexT Advertising',
                    companyWebsite: 'http://next.advertising.ro',
                },
                {
                    content: this.$t('budgets_landing_page.testimonial_8_text', { 'lineBreak': '<br/>' }),
                    imagePath: '/images/marketing/silvia-dragsan.jpg',
                    name: 'Silvia Drăgșan',
                    jobTitle: 'Performance Media Manager RO, BG, HU',
                    companyName: 'eMAG',
                    companyWebsite: 'https://emag.ro',
                },
            ];

            return testimonials;
        },

        testimonialsChunks() {
            return this.chunkArray(this.testimonials, 3);
        },
    },

    methods: {
        chunkArray(arr, chunkCount) {
            const chunks = [];
            while(arr.length) {
                const chunkSize = Math.ceil(arr.length / chunkCount--);
                const chunk = arr.slice(0, chunkSize);
                chunks.push(chunk);
                arr = arr.slice(chunkSize);
            };
            return chunks;
        },
    },
};
</script>
